import { render, staticRenderFns } from "./WarningIcon.vue?vue&type=template&id=7650d49c&scoped=true&"
import script from "./WarningIcon.vue?vue&type=script&lang=js&"
export * from "./WarningIcon.vue?vue&type=script&lang=js&"
import style0 from "./WarningIcon.vue?vue&type=style&index=0&id=7650d49c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7650d49c",
  null
  
)

export default component.exports